import React, { Component } from "react";
import Select from "react-select";

// Components
import ErrorWrap from "../../../utils/error-success/ErrorWrap";
import CircleLoader from "../CircleLoader";

class ProfileTableWorkLocation extends Component {
	render() {
		const {
			user,
			inProgress,
			personalFieldsErrors,
			reviewerOptionsLoading,
			reviewerOptionsError,
			reviewerOptions,
			translations
		} = this.props;

		return (
			<React.Fragment>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.address_work ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.address}:</th>
					<td>
						<input
							type="text"
							id="address_work"
							value={user.address_work}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder={
								translations.sections.reviewer_form.work_address_placeholder
							}
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.city_work ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.city}:</th>
					<td>
						<input
							type="text"
							id="city_work"
							value={user.city_work}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder={translations.sections.reviewer_form.work_city_placeholder}
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.postal_work ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.postal}:</th>
					<td>
						<input
							type="text"
							id="postal_work"
							value={user.postal_work}
							maxLength="9"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder={
								translations.sections.reviewer_form.work_postal_placeholder
							}
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.province_work
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.province}:</th>
					<td>
						{reviewerOptionsError ? (
							<ErrorWrap>{reviewerOptionsError}</ErrorWrap>
						) : (
							<React.Fragment>
								{!!reviewerOptionsLoading && <CircleLoader />}

								{!!reviewerOptions &&
									reviewerOptions.locations &&
									reviewerOptions.locations.provinces && (
										<Select
											classNamePrefix="react-select"
											placeholder={
												translations.sections.form_elements.select_one
											}
											isClearable={false}
											isDisabled={inProgress}
											name={`province_work`}
											value={reviewerOptions.locations.provinces.filter(
												({ abbreviation }) =>
													abbreviation === user.province_work
											)}
											onChange={({ abbreviation }) => {
												this.props.updateSelectedValue(
													abbreviation,
													"province_work"
												);
											}}
											options={reviewerOptions.locations.provinces}
											getOptionLabel={({ name }) => name}
											getOptionValue={({ abbreviation }) => abbreviation}
										/>
									)}
							</React.Fragment>
						)}
					</td>
				</tr>
			</React.Fragment>
		);
	}
}

export default ProfileTableWorkLocation;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/profile-table/ProfileTableWorkLocation.js